export const Images = {
  deFlag: require('../assets/flags/de.svg'),
  enFlag: require('../assets/flags/en.svg'),
  svFlag: require('../assets/flags/sv.svg'),
};
